import React from "react";
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";
import { MyHrContractCard } from "my-hr/components";
import { useMyHrContract, useMyHrEmployee } from "my-hr/hooks";
import {
  MyTimeAdmissionCardByAdmin,
  MyTimeOvertimeFrame,
  MyTimePageHeader,
  MyTimeRemainsFrame,
  MyTimeShowRequestCardExaminer,
  MyTimeWorkTimeBalanceFrameBox,
  MyTimeWorkingTimeFrame,
} from "my-time/components";
import {
  useMyTimeActualDate,
  useMyTimeMessagesList,
  useMyTimeMonthlyWorkTimeBalance,
  useMyTimeRequest,
} from "my-time/hooks";
import { OcPageNameTitle, OcPageTransition } from "oc/components";
import { useOcIsMobile } from "oc/hooks";

export const MyTimeEmployeeRequestPage = () => {
  let { contract, employee, id } = useParams<{
    contract: string;
    employee: string;
    id: string;
  }>();
  const { date, formattedDate, year, month, handleDateChange } =
    useMyTimeActualDate();

  const isMobile = useOcIsMobile();

  const { data: contractData } = useMyHrContract({
    contract: contract,
  });

  const { data: employeeData } = useMyHrEmployee({
    employeeId: employee,
  });

  const { data, loading, error, refetch } = useMyTimeRequest({ _id: id });

  const {
    data: messagesData,
    loading: messagesLoading,
    error: messagesError,
  } = useMyTimeMessagesList({ request: id });

  const {
    data: monthlyWorkTimeBalanceData,
    loading: monthlyWorkTimeBalanceLoading,
  } = useMyTimeMonthlyWorkTimeBalance({
    contractCode: contract,
    year,
    month,
  });

  const minHeight = monthlyWorkTimeBalanceData?.startBalance !== -1 ? 285 : 178;

  return (
    <OcPageTransition>
      <OcPageNameTitle title="Dolgozói kérelem" goBack={true} />
      <Box padding={isMobile ? "0px 0px 16px 0px" : "0px 16px 16px 16px"}>
        <MyTimePageHeader
          formattedDate={formattedDate}
          date={date}
          onDateChange={handleDateChange}
          examinerPage={true}
          isMobile={isMobile}
        />
        <Box height="16px" />
        <MyHrContractCard employee={employeeData} contract={contractData} />
        <Box height="16px" />
        <Box display="flex" flexDirection={isMobile ? "column" : "row"}>
          <Box width={isMobile ? "100%" : "584px"}>
            <MyTimeShowRequestCardExaminer
              data={data}
              messages={messagesData}
              loading={loading || messagesLoading}
              error={error || messagesError}
              employeeCode={employee}
              contractCode={contract}
              isMobile={isMobile}
              refetch={refetch}
            />
          </Box>
          {isMobile && <Box height="16px" />}
          <Box width="16px" />
          <Box
            display="flex"
            flexDirection="column"
            width={isMobile ? "100%" : "500px"}
          >
            <MyTimeWorkingTimeFrame
              contractCode={contract}
              year={year}
              month={month}
              minHeight={minHeight}
            />
            <Box height="16px" />
            <MyTimeRemainsFrame
              contractCode={contract}
              year={year}
              month={month}
              minHeight={minHeight}
            />
            <Box height="16px" />
            <MyTimeOvertimeFrame
              contractCode={contract}
              year={year}
              month={month}
              minHeight={minHeight}
            />
            <Box height="16px" />
            {monthlyWorkTimeBalanceData?.startBalance !== -1 && (
              <MyTimeWorkTimeBalanceFrameBox
                data={monthlyWorkTimeBalanceData}
                loading={monthlyWorkTimeBalanceLoading}
              />
            )}
          </Box>
        </Box>
        <Box height="16px" />
        <MyTimeAdmissionCardByAdmin
          contractCode={contract}
          employeeCode={employee}
          year={year}
          month={month}
          isMobile={isMobile}
          changeMyTimeEnabled={true}
          changeWorkingTimeEnabled={true}
        />
      </Box>
    </OcPageTransition>
  );
};

export default MyTimeEmployeeRequestPage;
